var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "userForm",
      staticClass: "user-form",
      attrs: {
        model: _vm.model,
        rules: _vm.rules,
        "label-width": "9.5em",
        "label-position": "left"
      }
    },
    [
      _vm.programName !== "UserMasterChangePassword"
        ? [
            _c(
              "div",
              { staticClass: "el-form--inline" },
              [
                _c("UserId", {
                  attrs: {
                    required: !_vm.searchMode,
                    searchCond: _vm.searchMode,
                    disabled: _vm.editMode,
                    autofocus: !_vm.editMode,
                    "autocomplete-list": _vm.autocompleteUserIdSet
                  },
                  model: {
                    value: _vm.userId,
                    callback: function($$v) {
                      _vm.userId = $$v
                    },
                    expression: "userId"
                  }
                }),
                _c("Blank")
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "el-form--inline" },
              [
                _c("UserName", {
                  attrs: {
                    required: !_vm.searchMode,
                    searchCond: _vm.searchMode,
                    "autocomplete-list": _vm.autocompleteUserNameSet
                  },
                  model: {
                    value: _vm.userName,
                    callback: function($$v) {
                      _vm.userName = $$v
                    },
                    expression: "userName"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "el-form--inline" },
              [
                _c("PhoneNumber", {
                  attrs: {
                    required: !_vm.searchMode,
                    searchCond: _vm.searchMode,
                    "autocomplete-list": _vm.phoneNumberSet
                  },
                  model: {
                    value: _vm.phoneNumber,
                    callback: function($$v) {
                      _vm.phoneNumber = $$v
                    },
                    expression: "phoneNumber"
                  }
                }),
                _c("Email", {
                  attrs: {
                    required: !_vm.searchMode,
                    searchCond: _vm.searchMode,
                    "autocomplete-list": _vm.emailSet
                  },
                  model: {
                    value: _vm.email,
                    callback: function($$v) {
                      _vm.email = $$v
                    },
                    expression: "email"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "el-form--inline" },
              [
                _vm.formMode === "search"
                  ? [
                      _c("CustomerCodeInput", {
                        attrs: {
                          required: !_vm.searchMode,
                          searchCond: _vm.searchMode,
                          "autocomplete-list": _vm.autocompleteCustomerCodeSet,
                          disabled: _vm.editMode
                        },
                        model: {
                          value: _vm.customerCode,
                          callback: function($$v) {
                            _vm.customerCode = $$v
                          },
                          expression: "customerCode"
                        }
                      })
                    ]
                  : [
                      _c("CustomerCodeSelect", {
                        attrs: {
                          disabled: _vm.programName === "UserInformation",
                          required:
                            !_vm.searchMode &&
                            _vm.programName !== "UserInformation",
                          searchCond: _vm.searchMode,
                          initialize: true,
                          ownCompany: true
                        },
                        model: {
                          value: _vm.customerCode,
                          callback: function($$v) {
                            _vm.customerCode = $$v
                          },
                          expression: "customerCode"
                        }
                      })
                    ],
                _c("RoleId", {
                  attrs: {
                    disabled: _vm.programName === "UserInformation",
                    required:
                      !_vm.searchMode && _vm.programName !== "UserInformation",
                    searchCond: _vm.searchMode,
                    initialize: true
                  },
                  model: {
                    value: _vm.roleId,
                    callback: function($$v) {
                      _vm.roleId = $$v
                    },
                    expression: "roleId"
                  }
                })
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "el-form--inline changePassword" },
              [
                _vm.loginUserRoleId === "admin"
                  ? [
                      _c("Blank"),
                      _vm.editMode
                        ? _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.changePassword,
                                callback: function($$v) {
                                  _vm.changePassword = $$v
                                },
                                expression: "changePassword"
                              }
                            },
                            [_vm._v("パスワードをリセットする")]
                          )
                        : _vm._e()
                    ]
                  : _vm._e()
              ],
              2
            )
          ]
        : [
            _c("Password", {
              attrs: { required: true, label: "新パスワード" },
              model: {
                value: _vm.passWord,
                callback: function($$v) {
                  _vm.passWord = $$v
                },
                expression: "passWord"
              }
            }),
            _c("Password", {
              attrs: { required: true, label: "確認パスワード" },
              model: {
                value: _vm.passWordConfirm,
                callback: function($$v) {
                  _vm.passWordConfirm = $$v
                },
                expression: "passWordConfirm"
              }
            })
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }